import { lazy } from 'react';

const NotFound = lazy(() => import('../components/NotFound'));
const userManagementRouter = lazy(() => import('../views/userManagement/AdminUsers/adminUsers.router'));
const CmsRouter = lazy(() => import('../views/cms/cms.router'));
const ApprovedDomainsRouter = lazy(() => import('../views/ApprovedDomains/approvedDomains.router'));
const UsersApprovalRouter = lazy(() => import('../views/usersApproval/usersApproval.router'));
const InventoryManagementRouter = lazy(() => import('../views/inventoryManagement/inventoryManagement.router'));
const HomePage = lazy(() => import('../views/HomePage/HomePage'));
const ProposalRequestsRouter = lazy(() => import('../views/proposalRequests/proposalRequests.router'));
const FeaturedContentRouter = lazy(() => import('../views/featuredContent/featuredContent.router'));
const MessageCenterRouter = lazy(() => import('../views/messages/messages.router'));
const SettingsRouter = lazy(() => import('../views/settings/setting.router'));
const OrdersManagementRouter = lazy(() => import('../views/ordersManagement/ordersManagement.router'));
const InvoicesRouter = lazy(() => import('../views/invoices/invoices.router'));
const Notifications = lazy(() => import('../views/notifications/notifications.router'));
const DashboardRouter = lazy(() => import('../views/dashboard/dashboard.router'));
const ReportsRouter = lazy(() => import('../views/reports/reports.router'));

export const MainRouter = [
  {
    path: '/dashboard/*',
    name: 'dashboard',
    component: DashboardRouter,
    exact: true,
  },
  {
    path: '/user/*',
    name: 'userManagement',
    component: userManagementRouter,
    exact: true,
  },
  {
    path: '/cms/*',
    name: 'cms',
    component: CmsRouter,
    exact: true,
  },
  {
    path: '/approved-domains/*',
    name: 'approvedDomains',
    component: ApprovedDomainsRouter,
    exact: true,
  },
  {
    path: '/users-approval/*',
    name: 'usersApproval',
    component: UsersApprovalRouter,
    exact: true,
  },
  {
    path: '/featured-content/*',
    name: 'featuredContent',
    component: FeaturedContentRouter,
    exact: true,
  },
  {
    path: '/inventory-management/*',
    name: 'inventoryManagement',
    component: InventoryManagementRouter,
    exact: true,
  },
  {
    path: '/proposal-requests/*',
    name: 'proposalRequests',
    component: ProposalRequestsRouter,
  },
  {
    path: '/message/*',
    name: 'messageCenter',
    component: MessageCenterRouter,
    exact: true,
  },
  {
    path: '/settings/*',
    name: 'settings',
    component: SettingsRouter,
    exact: true,
  },
  {
    path: '/orders/*',
    name: 'orders',
    component: OrdersManagementRouter,
    exact: true,
  },
  {
    path: '/invoice/*',
    name: 'invoice',
    component: InvoicesRouter,
    exact: true,
  },
  {
    path: '/notification/*',
    name: 'notifications',
    component: Notifications,
    exact: true,
  },
  {
    path: '/reports/*',
    name: 'reports',
    component: ReportsRouter,
    exact: true,
  },
  {
    path: '/',
    name: 'homePage',
    component: HomePage,
    exact: true,
  },
  {
    path: '*',
    name: 'NOT Found',
    component: NotFound,
  },
];
